import React from 'react'
import { Link, Outlet} from 'react-router-dom'
import 'animate.css';

// import { useState, useEffect } from 'react'
// import axios from 'axios'

function Movies() {
  //     const [movies, setMovies] = useState([])
  //     const navigate = useNavigate();

  //   const url = `https://api.themoviedb.org/3/genre/movie/list?api_key=ebec19ef717c8e83798a235dedd97d8b`

  //   useEffect(() => {
  //     axios.get(url)
  //       .then((response) => {
  //       setMovies(response.data.genres)
  //     })
  //   },[])

  //   console.log(movies)
  return (
    <>
      <div className="bg-[#f3eded] w-full h-auto">
        <h1 className="px-8 text-3xl font-[700] py-6">Disney Movies</h1>
        <div className="px-20   ">
          <nav className='py-4 font-bold'>
          <Link to="action" className='px-8 hover:text-blue-600 animate__animated animate__bounce '>Action
                      
            </Link>
            {/* <div ></div> */}

            <Link to="fantasy" className='px-8 hover:text-blue-600'>Fantasy</Link>

            <Link to="history" className='px-8 hover:text-blue-600'>History</Link>

            <Link to="comedy" className='px-8 hover:text-blue-600'>Comedy</Link>

            <Link to="crime" className='px-8 hover:text-blue-600'>Crime</Link>

            <Link to="documentary" className='px-8 hover:text-blue-600'>Documentary</Link>

            <Link to="horror" className='px-8 hover:text-blue-600'>Horror</Link>

            <Link to="music" className='px-8 hover:text-blue-600'>Music</Link>
          </nav>
          <Outlet />
        </div>
      </div>
    </>
  )
}

export default Movies
